module.exports = __webpack_public_path__ + "05_long_brown.994a1e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/05_long_brown.png
// module id = x1yi
// module chunks = 0